import { removeWhitespaces } from './stringOperation'

export const IS_VALID_EMAIL =
  /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/

export function escapeRegExp(text: string): string {
  return text.replace(/[-[\]{}()*+?.,\\^$|]/g, '\\$&')
}

export function isStringifiedArrayOfObjects(string: string = ''): boolean {
  return /^\[{.*\}]$/.test(removeWhitespaces(string))
}

const IS_AZURITE_SHORTCUT = /(?:^|;)UseDevelopmentStorage=true(?:;|$)/
const IS_VALID_ENDPOINT = /(?:^|;)(?:Blob|Queue|Table)Endpoint=(http?:\/\/[^;]*)/g
const IS_VALID_LOCALHOST = /^http?:\/\/(?:localhost|127\.0\.0\.1|\[::1\])(?::1000[0-2])?(\/.*)?$/

export function isLocalConnectionString(connectionString: string = ''): boolean {
  if (!connectionString?.trim()) {
    return false
  }

  // Strip outer variable assignment / quotes
  const raw = connectionString.replace(/^\w+=["']?/, '').replace(/["']$/, '')

  // Check for Azurite development shortcut
  if (IS_AZURITE_SHORTCUT.test(raw)) {
    return true
  }

  let match
  const matches = []

  while ((match = IS_VALID_ENDPOINT.exec(connectionString)) !== null) {
    matches.push(match)
  }

  const endpoints = matches.map(match => match[1]?.trim())
  return endpoints.length === 3 && endpoints.every(endpoint => IS_VALID_LOCALHOST.test(endpoint))
}
